"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const DropdownFilterCell = (props) => {
    const onChange = (event) => {
        const value = event.target.value;
        const hasValue = value && value !== props.defaultItem;
        props.onChange({
            value: hasValue ? event.target.value : '',
            operator: hasValue ? 'eq' : '',
            syntheticEvent: event.syntheticEvent
        });
    };
    const onClearButtonClick = (event) => {
        event.preventDefault();
        props.onChange({
            value: '',
            operator: '',
            syntheticEvent: event
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'k-filtercell' }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_dropdowns_1.DropDownList, { data: props.data, onChange: onChange, itemRender: props.itemRender, valueRender: props.valueRender, defaultItem: props.defaultItem, value: props.value || props.defaultItem }), (0, jsx_runtime_1.jsx)(kendo_react_buttons_1.Button, { title: 'Clear', onClick: onClearButtonClick, icon: 'filter-clear' })] })));
};
exports.default = DropdownFilterCell;
